module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/ostschweiz-aa08f930fd8d38c069ab5858d9985291.jpg";